import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class PanelsSchemaService {
  constructor(
    private http: HttpClient //
  ) {}

  getPanelSchema(materialId: number, panelUUID: string, link: string): Promise<Blob> {
    const httpParams = new HttpParams() //
      .set('materialId', materialId.toString())
      .set('panelUUID', panelUUID);

    return new Promise((resolve, reject) => {
      this.http
        .get(link, { params: httpParams, responseType: 'blob' }) //
        .subscribe((response: Blob) => {
          resolve(response);
        }, reject);
    });
  }
}
